export default (val) => {
  const alphaNum = val ? globalThis.$utils.cpfCnpjMask(val, true) : "";
  if (alphaNum.length !== 14) {
    return alphaNum;
  }
  return alphaNum.replace(
    /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/i,
    "**.**.$3/$4-$5",
  );
};
